import RemoteReloadingElement from '../../../shared/components/remote-reloading-element';
import AutomaticElementReloader from '../automatic-element-reloader';

const FETCH_UNEXTRACTED_BOOKMARKS_INTERVAL = 5000;

export default class BookmarkTileReloader extends AutomaticElementReloader {
  constructor(element, opts) {
    super(element, {intervalDelay: FETCH_UNEXTRACTED_BOOKMARKS_INTERVAL});

    this.tileListComponent = opts.tileListComponent;
  }

  unbindEvents() {
    super.unbindEvents();

    if (this.remoteReloadingElements) {
      this.remoteReloadingElements.forEach((element) => element.unbindEvents());
    }
  }

  handleAJAXsuccess(data) {
    super.handleAJAXsuccess(...arguments);

    const object = $('<div />').html(data);

    if (!object.children().first().hasClass('bookmarkList-item--unextracted')) {
      this.unbindEvents();

      this.$element.html(object.find('.bookmarkList-item').html());
      this.$element.removeClass('bookmarkList-item--unextracted');

      this.tileListComponent.reload();
    }

    this.remoteReloadingElements = RemoteReloadingElement.initialize(
      this.$element
    );
  }

  handleAJAXfailure() {
    super.handleAJAXfailure(...arguments);

    this.unbindEvents();
  }
}
